export const GET_PROFILES_REQUEST = 'GET_PROFILES_REQUEST';
export const GET_PROFILES_FAILURE = 'GET_PROFILES_FAILURE';
export const GET_PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS';
export const LOAD_MORE_PROFILES_SUCCESS = 'LOAD_MORE_PROFILES_SUCCESS';

export const GET_PROFILE_FIELDS_FAILURE = 'GET_PROFILE_FIELDS_FAILURE';
export const GET_PROFILE_FIELDS_SUCCESS = 'GET_PROFILE_FIELDS_SUCCESS';

export const SELECT_PROFILES_PROFILE = 'SELECT_PROFILES_PROFILE';
export const SHOW_PROFILES_DIALOG = 'SHOW_PROFILES_DIALOG';

export const SET_PAGE_COUNT = 'SET_PAGE_COUNT';
export const RESET_PAGE_COUNT = 'RESET_PAGE_COUNT';
export const RESET_PROFILES = 'RESET_PROFILES';

export const SET_PROFILES_COUNT = 'SET_PROFILES_COUNT';
export const SHOW_DISPLAY_PROFILES = 'SHOW_DISPLAY_PROFILES';
export const SET_IS_SEARCHING = 'SET_IS_SEARCHING';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_DEMOGRAPHIC_FILTERS = 'SET_DEMOGRAPHIC_FILTERS';
export const SET_CAMPAIGN_SURVEY_FILTERS = 'SET_CAMPAIGN_SURVEY_FILTERS';
export const SET_PROFILES_FILTER_FIELDS = 'SET_PROFILES_FILTER_FIELDS';

export const GET_PROFILE_IDENTITY_REQUEST = 'GET_PROFILE_IDENTITY_REQUEST';
export const GET_PROFILE_IDENTITY_FAILURE = 'GET_PROFILE_IDENTITY_FAILURE';
export const GET_PROFILE_IDENTITY_SUCCESS = 'GET_PROFILE_IDENTITY_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutation-types.js